import { FC, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { State } from 'redux/initialState';
import { Board } from 'types';
import { BoardEntityTypes } from 'types/Board';

import { useGetActualSociety } from 'hooks/useGetActualSociety';

import Page from 'modules/_shared/components/Pages/Page';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import { CardToShow } from 'modules/_shared/components/BoardsSummarySection/types/CardsToShow';
import BoardsListHeader from 'modules/_shared/components/BoardsListHeader';
import { boardsViewTypes } from 'modules/_shared/components/BoardsListHeader/constants/boardsViewTypes';
import RecentBoardsSection from 'modules/_shared/components/RecentBoardsSection';
import BoardsSummarySection from 'modules/_shared/components/BoardsSummarySection';
import { boardEntityTypes } from 'modules/_shared/components/BoardsListHeader/constants/boardEntityTypes';
import { useGetBoardsList } from 'modules/_shared/components/BoardsListHeader/hooks/useGetBoardsList';
import { useGetBoardsSectionPermissions } from 'modules/boards/hooks/useGetBoardsSectionPermissions';

const cardsToShow: CardToShow = {
  preparing: true,
  active: true,
  closed: true,
};

const BasicBoardList: FC = () => {
  const { societyId } = useParams();

  const boards: Board[] = useSelector((state: State) => state.boards);

  const [view] = useState<string>(boardsViewTypes.DASHBOARD);

  const { isLoading } = useGetBoardsList(societyId);
  const { isAdmin } = useGetBoardsSectionPermissions().data;

  useGetMenu();
  useGetActualSociety(societyId);

  const handleChangeView = () => {};

  const filteredBoards: Board[] = useMemo(() => {
    if (!boards?.length) return [];
    if (isAdmin) return boards;

    const visibleBoards = boards.filter((board) => board?.isVisible);

    return visibleBoards;
  }, [boards, isAdmin]);

  return (
    <Page id="basic-boards-list-page">
      <BoardsListHeader
        boardType={boardEntityTypes.BASIC_BOARD as BoardEntityTypes}
        viewType={view}
        boardsCount={filteredBoards?.length || 0}
        onChangeView={handleChangeView}
      />

      {isAdmin && (
        <BoardsSummarySection
          boardType={boardEntityTypes.BASIC_BOARD as BoardEntityTypes}
          boards={filteredBoards}
          cardsToShow={cardsToShow}
        />
      )}

      {boards?.length > 0 && (
        <RecentBoardsSection
          boards={filteredBoards}
          boardType={boardEntityTypes.BASIC_BOARD as BoardEntityTypes}
        />
      )}

      {isLoading && <CustomLoading />}
    </Page>
  );
};

export default BasicBoardList;
